import { isEmptyValue } from "../helper/isEmptyValue";
import type { SyncValidationRule } from "../types/validation";

function numberRule(
  name: string,
  dependencies: readonly unknown[],
  predicate: (value: number) => boolean,
  params?: Record<string, string | number>,
): SyncValidationRule<number | null | undefined> {
  return {
    name,
    kind: "sync",
    dependencies,
    validate(value) {
      if (isEmptyValue(value)) {
        return undefined;
      }
      return typeof value === "number" && predicate(value)
        ? undefined
        : { messageKey: `validation.${name}`, params };
    },
  };
}

export function finiteNumber(): SyncValidationRule<number | null | undefined> {
  return numberRule("finiteNumber", [], Number.isFinite);
}

export function integer(): SyncValidationRule<number | null | undefined> {
  return numberRule("integer", [], Number.isInteger);
}

export function minValue(min: number): SyncValidationRule<number | null | undefined> {
  return numberRule("minValue", [min], (value) => value >= min, { min });
}

export function maxValue(max: number): SyncValidationRule<number | null | undefined> {
  return numberRule("maxValue", [max], (value) => value <= max, { max });
}

export function multipleOf(step: number): SyncValidationRule<number | null | undefined> {
  return numberRule(
    "multipleOf",
    [step],
    (value) => Number.isFinite(value) && Number.isInteger(value / step),
    { step },
  );
}

export function positive(): SyncValidationRule<number | null | undefined> {
  return numberRule("positive", [], (value) => value > 0);
}
